<template>
  <div class="login-card-content verification-code-options">
    <LoginCardHeading
      title="Código de autorização"
      description="Escolha como quer receber o código de autorização."
    />

    <MUIList
      :gap="2"
      orientation="column"
      fluid-items
      class="verification-code-options__list"
    >
      <CardButton
        v-for="option in options"
        :key="option.name"
        @click.native="handleOption(option.name)"
      >
        <MEInfoBlock
          :icon-name="option.icon"
          :icon-size="24"
          gap="6"
          icon-color="#00519D"
          vertical-alignment="center"
        >
          <h3 class="verification-code-options__title">{{option.title}}</h3>
          <p class="verification-code-options__description">{{option.text}}</p>
        </MEInfoBlock>
      </CardButton>
    </MUIList>

    <LoginCardDisclaimer
      text="Sem acesso ao celular ou e-mail no momento?"
      link-text="Use o código de reserva"
      @handle-disclaimer="$emit('step-changed', getSteps.THIRD)"
    />
  </div>
</template>

<script>
// CONFIG
import { TWO_FACTOR_SERVICES_ENUM } from "@home/js/components/login/2FA/config";

// COMPONENTS
import LoginCardHeading from '@home/js/components/login/LoginCardHeading';
import LoginCardDisclaimer from '@home/js/components/login/LoginCardDisclaimer';
import MUIList from "commons/js/components/organisms/MUIList";
import MEInfoBlock from 'commons/js/components/atoms/MEInfoBlock';
import CardButton from 'commons/js/components/atoms/CardButton';

// UTILS
import {defaultErrorHandler} from "commons/js/utils/default-error-handler";
import recaptcha from "commons/js/ReCAPTCHAv3";

export default {
  name: "VerificationCodeOptions",

  inject: [
    "user",
    "getSteps"
  ],

  components: {
    LoginCardHeading,
    LoginCardDisclaimer,
    CardButton,
    MUIList,
    MEInfoBlock
  },

  data() {
    return {
      options: [
        {
          name: TWO_FACTOR_SERVICES_ENUM.EMAIL,
          title: 'E-mail',
          text: `No e-mail ${this.user().email}`,
          icon: 'mail-outline'
        },
        {
          name: TWO_FACTOR_SERVICES_ENUM.SMS,
          title: 'SMS',
          text: `No celular ${this.user().phone}`,
          icon: 'phone-portrait-outline'
        },
        {
          name: TWO_FACTOR_SERVICES_ENUM.WHATSAPP,
          title: 'WhatsApp',
          text: `No celular ${this.user().phone}`,
          icon: 'logo-whatsapp'
        }
      ]
    }
  },

  methods: {
    /**
     * Handles the selected option by sending it to the server,
     * in order to receive the 2FA verification code through the related service.
     *
     * @param {string} name The service name.
     * @returns {void}
     */
    async handleOption(name) {
      this.$emit('start-loading');

      recaptcha('login_verification_code_options', async (token) => {
        try {
          const payload = {
            username: this.user().name,
            password: this.user().password,
            token: token,
            channels: [name]
          };

          await axios.post('/login', payload);

          this.$emit('channel-changed', name);
          this.$emit('step-changed', this.getSteps.FIRST);
        } catch (error) {
          this.$emit('handle-toast', defaultErrorHandler(error));
        } finally {
          this.$emit('finish-loading');
        }
      });
    }
  },
}
</script>

<style lang="stylus" scoped>
  .verification-code-options

    &__list
      width 100%
      margin 32px 0 36px

      @media screen and (min-width: 940px)
        margin 0 0 56px

    &__title
    &__description
      font-size 14px
      line-height 16px

    &__title
      font-weight 600

    &__description
      font-weight 400
      color #697882
</style>
